import React, { useContext } from 'react'

import { ThemeContext } from './Themer'

const useTheme = () => {
    return useContext(ThemeContext)
}
export default useTheme
